<template>
  <div
    class="add_keyWords_layer m-lr-11"
    @mousedown.stop
  >
    <div class="contentPart clearfix">
      <p class="icon_left">
        <el-popover
          v-if="iconIsShow == 'left'"
          placement="top-start"
          popper-class="popover_style"
          :width="tipsWidth"
          trigger="hover"
          :content="tips"
        >
          <span
            class="icon_info iconfont icon-wenhao"
            slot="reference"
          ></span>
        </el-popover>
      </p>
      <span
        class="title"
        v-text="title"
        :style="{
          width: titleWidth + 'px'
        }"
      ></span>
      <el-popover
        v-if="iconIsShow == 'right'"
        placement="top-start"
        popper-class="popover_style"
        :width="tipsWidth"
        trigger="hover"
        :content="tips"
      >
        <span
          class="icon_info icon_info_right iconfont icon-wenhao"
          slot="reference"
        ></span>
      </el-popover>
      <div
        class="keyWordsLine"
        v-for="(item,index) in hot_keyWords"
        :key='index'
      >
        <span class="wordsItem">{{item.words}}</span>
        <span
          class="closeIcon el-icon-close"
          @click="clearWords(index)"
        ></span>
      </div>
      <div class="addPart" v-if="hot_keyWords.length<10">
        <el-input
          v-show="editType"
          ref='addKeywords'
          v-model="hot_key_word"
          :maxlength='10'
          @blur='showBtn'
          @input='changeWords'
        ></el-input>
        <span
          v-show="!editType"
          class="el-icon-plus addIcon"
          @click="changeType"
        ></span>
      </div>

    </div>
  </div>
</template>

<script>
import i18n from '../../language/index'

export default {
  name: 'add_keyWords',
  props: {
    titleWidth: {
      type: String,
      default: '40'
    },
    title: { // 组件的标题
      type: String,
      default: ''
    },
    type: { // 组件的类型  one_level 一级组件 two_level 二级组件
      type: String,
      default: 'two_level'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    iconIsShow: { // 图标位置（'' 不显示 left 左边显示 right 右边显示）
      type: String,
      default: ''
    },
    tips: { // 图标提示信息
      type: String,
      default: ''
    },
    tipsWidth: {
      type: String,
      default: '310'
    },
    hotKeyWords: {
      type: Array,
    }
  },
  data () {
    return {
      editType: false,
      hot_key_word: '',
      hot_keyWords: this.hotKeyWords
    }
  },
  watch: {
    hot_keyWords (val) {
      this.$emit('update:hotKeyWords', val);//双向数据绑定
    },
    'hotKeyWords' (val) {
      this.hot_keyWords = val
    },
  },
  methods: {
    changeWords(val){
      if(val.length == 10){
        this.$message.warning(this.tips)
      }
    },
    clearWords (index) {
      this.hot_keyWords.splice(index, 1)
    },
    changeType () {
      this.editType = true
      this.$nextTick(() => {
        this.$refs.addKeywords.focus()
      })
    },
    showBtn () {
      if (this.hot_key_word) {
        let tag = this.hot_keyWords.filter(e => {
          if (e.key === this.hot_key_word) {
            return true
          }
        })
        if (tag.length === 0) {
          let data = {
            key: this.hot_key_word,
            words: this.hot_key_word
          }
          this.hot_keyWords.push(data)
        }
      }
      this.editType = false
      this.hot_key_word = ''
    }
  },
  mounted () {

  },
}
</script>

<style lang="scss" scoped>
.title {
  float: left;
  font-size: 13px;
  text-align: right;
  overflow: hidden;
  height: 32px;
  line-height: 32px;
}

.icon_left {
  display: inline-block;
  position: relative;
  left: 0;
  float: left;
  font-size: 13px;
  text-align: right;
  overflow: hidden;
  height: 32px;
  line-height: 32px;
}
.keyWordsLine {
  float: left;
  display: inline-block;
  height: 34px;
  line-height: 34px;
  position: relative;
  float: left;
  margin: 0px 10px 10px 0;
  cursor: pointer;
  .wordsItem {
    display: inline-block;
    height: 34px;
    line-height: 34px;
    background: #f1f1f1;
    padding: 0 10px;
    border-radius: 2px;
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 200px;
    white-space: nowrap;
    display: inline-block;
    color: #666;
    -ms-user-select: none;
    user-select: none;
  }
  .closeIcon {
    position: absolute;
    display: none;
    width: 14px;
    height: 14px;
    font-size: 12px;
    padding: 0 1px;
    line-height: 14px;
    right: -6px;
    top: -6px;
    cursor: pointer;
  }
}
.keyWordsLine:hover {
  .closeIcon {
    display: block;
    color: #fff;
    background-color: #ff5414;
    border-radius: 999px;
  }
}
.addPart {
  float: left;
  .addIcon {
    display: inline-block;
    font-size: 14px;
    color: #333;
    width: 34px;
    height: 34px;
    line-height: 34px;
    padding: 0 10px;
    background-color: #f1f1f1;
  }
  .addIcon:hover {
    background-color: #0078d7;
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/my_add_keyWords/index.vue